import React, { ReactNode } from "react";
import { Box } from "@mui/material";
import desireCompanyLogo from "../../../assets/desire_company_fullname_logo_light_gray.svg";
import retailRmediLogo from "../../../assets/logo-transparent-tdc-only.png";

interface Props {
  isRegisterForm?: boolean;
  children: ReactNode;
}

export function BasicPage({ isRegisterForm, children }: Props) {
  return (
    <Box className="min-h-screen w-screen bg-page flex flex-col items-center justify-center gap-4 py-12">
      {/* <Box className="w-[160px]">
          <img
            className="size-full"
            alt="company-logo"
            src={desireCompanyLogo}
          />
        </Box> */}
      {isRegisterForm ? (
        <Box />
      ) : (
        <Box className="w-[300px]">
          <img className="size-full" alt="company-logo" src={retailRmediLogo} />
        </Box>
      )}
      {children}
    </Box>
  );
}
